// extracted by mini-css-extract-plugin
export default {"mainLayout":"RootLayout_mainLayout__o2j15"};